module.exports = __webpack_public_path__ + "img/config_portrait.dd99aee5.png";